var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridViewInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 8.667H2a.667.667 0 0 0-.667.666V14a.666.666 0 0 0 .667.667h4.666A.666.666 0 0 0 7.333 14V9.333a.667.667 0 0 0-.667-.666zM6 13.333H2.666V10H6v3.333zm8-12H9.333A.667.667 0 0 0 8.666 2v4.667a.667.667 0 0 0 .667.666H14a.667.667 0 0 0 .666-.666V2A.667.667 0 0 0 14 1.333zM13.333 6H10V2.667h3.333V6zM14 8.667H9.333a.667.667 0 0 0-.667.666V14a.666.666 0 0 0 .667.667H14a.666.666 0 0 0 .666-.667V9.333A.667.667 0 0 0 14 8.667zm-.667 4.666H10V10h3.333v3.333zm-6.667-12H2A.667.667 0 0 0 1.333 2v4.667A.667.667 0 0 0 2 7.333h4.666a.667.667 0 0 0 .667-.666V2a.667.667 0 0 0-.667-.667zM6 6H2.666V2.667H6V6z",
    fill: "#150349"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewInactiveIcon);
export default __webpack_public_path__ + "static/media/grid-view-inactive-icon.25f6f803206f874606e2b80e9e9d25ae.svg";
export { ForwardRef as ReactComponent };